export default __webpack_public_path__ + "static/media/chrysler.7a7ba1b9.svg";